"use strict";
/**
 * @license
 * Copyright Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUrl = exports.ResourceUrlPolicyHintsType = void 0;
/**
 * The type of the hints that can be passed to a ResourceUrlPolicy.
 */
var ResourceUrlPolicyHintsType;
(function (ResourceUrlPolicyHintsType) {
    ResourceUrlPolicyHintsType[ResourceUrlPolicyHintsType["STYLE_ELEMENT"] = 0] = "STYLE_ELEMENT";
    ResourceUrlPolicyHintsType[ResourceUrlPolicyHintsType["STYLE_ATTRIBUTE"] = 1] = "STYLE_ATTRIBUTE";
    ResourceUrlPolicyHintsType[ResourceUrlPolicyHintsType["HTML_ATTRIBUTE"] = 2] = "HTML_ATTRIBUTE";
})(ResourceUrlPolicyHintsType = exports.ResourceUrlPolicyHintsType || (exports.ResourceUrlPolicyHintsType = {}));
/**
 * Parses a URL. If the URL is invalid, returns URL instance with
 * `about:invalid`.
 */
function parseUrl(value) {
    try {
        return new URL(value, window.document.baseURI);
    }
    catch (e) {
        return new URL('about:invalid');
    }
}
exports.parseUrl = parseUrl;
